export default "__VITE_ASSET__d059ab41__"